document.addEventListener('DOMContentLoaded',function(){
  var sidebar=document.querySelector('.sidebar');
  var form=document.querySelector('#filter-form');
  if(!sidebar||!form||!document.body.className.includes('template-collection')) return;
  if(document.querySelector('.occasion-switcher')) return;

  var items=[
    {label:'Gimtadieniui',url:'/collections/dovanos-gimtadieniui',icon:'birthday'},
    {label:'Kalėdoms',url:'/collections/dovanos-kaledoms',icon:'christmas'},
    {label:'Krikštynoms',url:'/collections/dovanos-krikstynoms',icon:'gift'},
    {label:'Mamai',url:'/collections/dovanos-mamai',icon:'mom'},
    {label:'Įkurtuvėms',url:'/collections/dovanos-ikurtuvems',icon:'housewarming'},
    {label:'Vestuvėms',url:'/collections/dovanos-vestuvems',icon:'wedding'},
    {label:'Mokytojams',url:'/collections/dovanos-mokytojams',icon:'teacher'},
    {label:'Įmonėms',url:'/collections/dovanos-imonems',icon:'corporate'}
  ];

  var icons={
    birthday:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="9" width="16" height="11" rx="2"/><path d="M12 9v11M4 13h16M8 9c-1.5-1.2-1.6-3.5.3-3.7 1.6-.2 2.6 1.8 3.7 3.7 1.1-1.9 2.1-3.9 3.7-3.7 1.9.2 1.8 2.5.3 3.7"/></svg>',
    christmas:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l-6 8h4l-5 7h14l-5-7h4l-6-8z"/><path d="M12 18v3"/></svg>',
    gift:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="9" width="16" height="11" rx="2"/><path d="M12 9v11M4 13h16M8 9c-1.3-1.1-1.5-3 .2-3.3 1.6-.3 2.6 1.7 3.8 3.3 1.2-1.6 2.2-3.6 3.8-3.3 1.7.3 1.5 2.2.2 3.3"/></svg>',
    mom:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.8 4.6c-1.8-1.7-4.7-1.7-6.5.1L12 7l-2.3-2.3c-1.8-1.8-4.7-1.8-6.5-.1-1.9 1.9-1.8 5 .1 6.9L12 20l8.7-8.5c1.9-1.9 2-5 .1-6.9Z"/></svg>',
    housewarming:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></svg>',
    wedding:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="13" r="5"/><circle cx="15" cy="13" r="5"/></svg>',
    teacher:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 20l4-1 11-11a2.2 2.2 0 0 0-3-3L5 16l-1 4z"/><path d="M14 6l4 4"/></svg>',
    corporate:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="8" width="18" height="12" rx="2"/><path d="M9 8V6a3 3 0 0 1 6 0v2M3 13h18"/></svg>'
  };

  var path=window.location.pathname.replace(/\/$/,'');
  var wrap=document.createElement('div');
  wrap.className='occasion-switcher';
  wrap.innerHTML='<h3 class="occasion-switcher__title">Kitos progos</h3><div class="occasion-switcher__grid"></div>';
  var grid=wrap.querySelector('.occasion-switcher__grid');

  items.forEach(function(item){
    var a=document.createElement('a');
    a.href=item.url;
    a.className='occasion-switcher__item'+(path===item.url?' is-active':'');
    a.innerHTML='<span class="occasion-switcher__icon">'+(icons[item.icon]||icons.gift)+'</span><span class="occasion-switcher__label">'+item.label+'</span>';
    grid.appendChild(a);
  });

  var budget=document.querySelector('.budget-filter');
  if(budget&&budget.parentNode){
    budget.parentNode.insertBefore(wrap,budget.nextSibling);
  }else{
    form.insertBefore(wrap,form.firstChild);
  }
});
